import { render } from "./azure.vue?vue&type=template&id=c04e560c"
import script from "./azure.vue?vue&type=script&lang=js"
export * from "./azure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__